import './style.scss';
import MembersCofounder from './MembersCofounder';
import MembersFreelancer from './MembersFreelancer';
import MembersMentor from './MembersMentor';
import MembersTeam from './MembersTeam';
import React from 'react';
import SettingButton from './SettingButton';
import Toggle from 'react-toggle';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Row, Col, Media, Image } from 'react-bootstrap';

@injectIntl
@inject('membersStore', 'rootStore')
@observer
export default class MediaObject extends React.Component {
  render() {
    let { membersStore, member, items } = this.props;
    let { confirm } = membersStore;

    return (
      <Media className="media">
        <Media.Left align="middle">
          <Image
            width={100}
            src={member.user.profile_photo_url}
            alt="thumbnail"
            circle
          />
        </Media.Left>
        <Media.Body className="body">
          <h4>
            <a
              style={{ cursor: 'pointer' }}
              onClick={() => membersStore.toggleShowModal(member)}
            >
              {member.user.name}
            </a>
          </h4>
          <h5>{member.user.email}</h5>
          <Row>
            <Col sm={4}>
              {
                <div className="default-container">
                  <div className="role-container">
                    <h5>
                      {this.props.intl.formatMessage({ id: member.role })}
                    </h5>
                    &nbsp;&nbsp;
                    {member.role === 'ceo' || !membersStore.canManage ? null : (
                      <div id="setting-button-container">
                        <SettingButton
                          options="mRoles"
                          member={member}
                          handle={membersStore.handleRole}
                        />
                      </div>
                    )}
                  </div>
                  {member.role === 'ceo' || !membersStore.canManage ? null : (
                    <div className="toggle-container">
                      <label>
                        <h5>
                          {this.props.intl.formatMessage({ id: 'active' })}
                        </h5>
                      </label>
                      &nbsp;&nbsp;
                      <Toggle
                        checked={member.active}
                        onChange={e => {
                          if (confirm())
                            membersStore.handleActive(
                              member.id,
                              !member.active
                            );
                        }}
                      />
                    </div>
                  )}
                </div>
              }
            </Col>
            <Col sm={8}>
              {member.role === 'staff' ? (
                <MembersTeam member={member} />
              ) : member.role === 'co_founder' ? (
                <MembersCofounder member={member} items={items} />
              ) : member.role === 'freelancer' ? (
                <MembersFreelancer member={member} />
              ) : member.role === 'mentor' ||
                member.role === 'investor' ||
                member.role === 'advisor' ||
                member.role === 'ceo' ? (
                <MembersMentor member={member} items={items} />
              ) : null}
            </Col>
          </Row>
        </Media.Body>
      </Media>
    );
  }
}
